// ============================================================================
// app.home.light — migrated off the global read
// ============================================================================
// The Light-role Field Portal owns its planner, missed-daily inputs, and
// equipment-attention reads through narrow permanent resources. Header is
// excluded: it is shared shell chrome with independently owned
// task/notification reads.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'app.home.light',
  obligations: Object.freeze([
    Object.freeze({id: 'home.light.equipment.attention', owner: 'permanent'}),
    Object.freeze({id: 'home.light.planner', owner: 'permanent'}),
    Object.freeze({id: 'home.light.missed.inputs', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
